/* eslint-disabled */

export default class ReductionExtend {


  constructor (object?: any) {
  }

  postConstruct () {
  }
}
